export enum DateFilterRangeShortcut {
    TODAY = 'Today',
    LAST7 = 'Last7',
    LAST14 = 'Last14',
    LAST28 = 'Last28',
    CUSTOM = 'Custom'
}
